import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  type AddAdminUserPayload,
  type AdminUser,
  type UpdateAdminUserRolePayload
} from '../models/admin-user.model';

@Injectable({ providedIn: 'root' })
export class AdminUsersService {
  private readonly baseUrl = environment.baseUrl;

  constructor(private readonly http: HttpClient) {}

  getAllUsers(): Observable<AdminUser[]> {
    return this.http.get<AdminUser[]>(`${this.baseUrl}/AdminUsers/GetAllUsers`);
  }

  addUserByUco(payload: AddAdminUserPayload): Observable<AdminUser> {
    return this.http.post<AdminUser>(`${this.baseUrl}/AdminUsers/AddUserByUco`, payload);
  }

  updateUserRole(payload: UpdateAdminUserRolePayload): Observable<AdminUser> {
    return this.http.post<AdminUser>(`${this.baseUrl}/AdminUsers/UpdateUserRole`, payload);
  }

  deleteUser(uco: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/AdminUsers/DeleteUser/${encodeURIComponent(uco)}`);
  }
}
